import React from 'react';

const Offers = () => (
  <section style={{ padding: 24 }}>
    <h2>Special Offers</h2>
    <div style={{
      background: 'linear-gradient(90deg, #FFD700 60%, #FF4500 100%)',
      color: '#222',
      borderRadius: 10,
      padding: 24,
      fontWeight: 'bold',
      fontSize: 28,
      textAlign: 'center',
      boxShadow: '0 2px 12px #0002',
      marginBottom: 16
    }}>
      <span style={{ color: '#FF4500', fontSize: 36, marginRight: 12 }}>90% OFF</span>
      <span>on selected crackers! <span role="img" aria-label="fire">🔥</span></span>
    </div>
    <div style={{ textAlign: 'center', fontSize: 16 }}>
      <span style={{ background: '#fffbe6', padding: '4px 12px', borderRadius: 6, color: '#FF4500', fontWeight: 600 }}>
        Limited time offer. Grab your deal now!
      </span>
    </div>
  </section>
);

export default Offers;
